import { combineReducers } from "@reduxjs/toolkit";
import ege from './ege'
import eioc from './eioc'
import teachers from './teachers'
import staff from './staff'
import students from './students'
import vsoko from './vsoko'




const details = combineReducers({
  ege,
  eioc,
  teachers,
  staff,
  students,
  vsoko
})

export default details